import { Component, Injector } from '@angular/core'
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { DASHBOARD_FRONTEND } from './../environment';
import { LoadingService } from '@ar2/common';
import { Plncmm10000sc0000Page } from '../features/cmnfnc-base/pages/plncmm10000sc00-00/plncmm10000sc00-00.component.page'

/**
 * アプリケーションコンポーネント
 * @author nabla2.metamodel.generator
 */
@Component({
  templateUrl: 'app.html'
})
export class App {
  /**
   * Dashboard URL for iframe
   *
   * @type {SafeResourceUrl}
   * @memberof App
   */
  public dashboardUrl: SafeResourceUrl;

  /**
   * Root page
   *
   * @type {*}
   * @memberof App
   */
  rootPage:any = Plncmm10000sc0000Page

  /**
   *Creates an instance of App.
   * @param {Injector} injector
   * @memberof App
   */
  constructor(
    injector: Injector,
    public loading: LoadingService
  ) {
    this.dashboardUrl = injector.get(DomSanitizer).bypassSecurityTrustResourceUrl(DASHBOARD_FRONTEND);
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts